import {  REPLIES_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"
import notify from "@/utils/notify"


export const sendMessage = ({ commit,state },phone) => {
    
    const url = `${REPLIES_API}`
    const {fileReply,messageReply,parentReply,isLoading,pttReply} = state;

   if((pttReply == null && fileReply == null && messageReply == null) || isLoading || messageReply?.trim() == "" ){
       notify("Votre message ne peut pas etre envoye,Ressayez ulterieurement")
     
    return 
   }
    
    console.log(' run')
    commit(types.SET_SHOW_LOADING)
    commit(types.SET_NOT_REPLIED)
    var data = {
        phone,
        type:fileReply ? fileReply?.type :(pttReply ? "ptt":"chat"),
        // type:!fileReply ? 'chat' : (fileReply.type.includes('image') ? 'image' : (fileReply.type.includes('audio') ? 'audio':fileReply.type.includes('video') ?"video":'document')),
        content: fileReply ?? pttReply ?? messageReply,
        base64:'',
        file:fileReply ??  pttReply ?? null,
        fileName:fileReply?.name ??  null,
        caption:fileReply? (messageReply ?? ""):null,
        reply_id:parentReply ?parentReply.message_id : null,
    }

    const dataForm = new FormData()
    Object.keys(data).forEach((key)=>{
        dataForm.append(key,data[key])
    })

    commit(types.SET_SHOW_LOADING)
    commit(types.SET_NOT_REPLIED)

    backend({ url, data:dataForm, method: "POST",mulitpart:fileReply }).then(({ data }) => {
        commit(types.SET_REPLY, data.data ?? data)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE,data.message ?? "Super")
        commit(types.SET_CURRENT_ITEM, data)
        commit(types.SET_IS_REPLIED)
        commit(types.SET_FILE_REPLY,null)
        commit(types.SET_MESSAGE_REPLY,null)
        commit(types.SET_PARENT_REPLY,null)
        commit(types.SET_CHUNKER_REPLY,[])
        commit(types.SET_PTT_REPLY,null)
    }).catch((err) => {
        commit(types.SET_REPLY, null)
    notify("Le message n'a pas été envoyé,Ressayez plus tard")

        commit(types.SET_NOT_REPLIED)
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)

    })
}


export const resetData = ({ commit }) => {
    commit(types.RESET)
}



